module.exports = __webpack_public_path__ + "img/material.aa8338d9.svg";